import { cloneElement, ReactElement } from "react";
import "./styles.scss";

interface BadgeProps {
  icon?: ReactElement;
  text: string;
}

export default function Badge(props: BadgeProps) {
  const { icon, text } = props;

  const renderedIcon = icon
    ? cloneElement(icon, {
        className: "badge-icon",
      } as any)
    : null;

  return (
    <div className="badge-container">
      {renderedIcon}
      <span className="badge-text">{text}</span>
    </div>
  );
}
